import { render, staticRenderFns } from "./Products-grid.vue?vue&type=template&id=4cb0559e&"
import script from "./Products-grid.vue?vue&type=script&lang=js&"
export * from "./Products-grid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports